import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Chip,
    Stack,
} from '@mui/material';
import SipSchedulerModal from './SipSchedulerModal';
import FundDetailsAccordion from './FundDetailsAccordion';
import { MutualFund } from './types';

const MutualFundCard = ({ fund }: { fund: MutualFund }) => {
    const [sipOpen, setSipOpen] = useState(false);

    return (
        <>
            <Card sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Stack spacing={1}>
                        <Typography variant="h6">{fund.name}</Typography>

                        <Chip
                            size="small"
                            label={`${fund.risk} RISK`}
                             color={
                                fund.risk === 'LOW'
                                    ? 'success'
                                    : fund.risk === 'MEDIUM'
                                        ? 'warning'
                                        : 'error'
                            }
                        />

                        <Typography>NAV: ₦{fund.nav.toFixed(2)}</Typography>
                        <Typography variant="body2">
                            YTD Return: <strong>{fund.ytdReturn}%</strong>
                        </Typography>

                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => setSipOpen(true)}
                        >
                            Start SIP
                        </Button>

                        <FundDetailsAccordion
                            expenseRatio={1.5}
                            riskLevel={fund.risk}
                            factsheetUrl="#"
                            holdings={[
                                { name: 'MTN Nigeria', weight: 18 },
                                { name: 'GTCO', weight: 14 },
                                { name: 'Nestlé Nigeria', weight: 10 },
                            ]}
                        />
                    </Stack>
                </CardContent>
            </Card>

            <SipSchedulerModal
                open={sipOpen}
                onClose={() => setSipOpen(false)}
                fundName={fund.name}
            />
        </>
    );
};

export default MutualFundCard;
